import React from 'react';

import { PrimaryButton, ProButton } from '@components/Button/variants';
import IconAppleAppStore from '@components/Images/Rebranding/IconAppleAppStore';
import IconClose from '@components/Images/Rebranding/IconClose';
import IconGooglePlayStore from '@components/Images/Rebranding/IconGooglePlayStore';
import useEventTracking from '@hooks/useEventTracking';
import { ClickTarget, TrackingLocation, click } from '@tracking';

const DOWNLOAD_APP_LINK = 'https://theinformation.onelink.me/6IaG/3stnun15';

interface DownloadAppProps {
  handleClose: () => void;
  handleNext: () => void;
  isProSubscriber: boolean;
}

const DownloadApp = ({ handleClose, handleNext, isProSubscriber }: DownloadAppProps) => {
  const Button = isProSubscriber ? ProButton : PrimaryButton;
  const { trackEvent } = useEventTracking({
    location: TrackingLocation.UserOnboardingTooltip,
  });

  return (
    <div
      id="mobile-download-app-tooltip"
      className="relative flex min-h-[calc(100vh-252px)] w-[360px] max-w-[calc(100vw-32px)] flex-col items-center justify-center bg-grayscale-charcoal px-20 pb-16 pt-48"
    >
      <button
        type="button"
        className="absolute right-16 top-16 cursor-pointer touch-manipulation border-none bg-transparent p-0"
        onClick={handleClose}
        aria-label="Close"
      >
        <IconClose className="stroke-2 text-white" height={26} width={26} />
      </button>
      <div className="flex flex-col items-center gap-24">
        <h2 className="my-0 text-center font-suisse-screen text-headline-alt-sm font-medium text-white">
          You&apos;re all set
        </h2>
        <div className="flex flex-col items-center gap-8">
          <p className="my-0 text-center font-suisse-screen text-byline-lg text-white">
            Download the app
          </p>
          <div className="flex items-center justify-center gap-16">
            <a
              href={DOWNLOAD_APP_LINK}
              target="_blank"
              rel="noreferrer"
              className="flex h-40 shrink-0 items-center overflow-hidden rounded-[5px] border border-black bg-white"
              aria-label="Download on Google Play"
              onClickCapture={() =>
                trackEvent(
                  click({ clickTarget: ClickTarget.DownloadApp, clickText: 'google_play' })
                )
              }
            >
              <IconGooglePlayStore className="h-40 w-auto" />
            </a>
            <a
              href={DOWNLOAD_APP_LINK}
              target="_blank"
              rel="noreferrer"
              className="flex h-40 shrink-0 items-center overflow-hidden rounded-[7px] border border-black bg-white"
              aria-label="Download on the App Store"
              onClickCapture={() =>
                trackEvent(click({ clickTarget: ClickTarget.DownloadApp, clickText: 'app_store' }))
              }
            >
              <IconAppleAppStore className="h-40 w-auto" />
            </a>
          </div>
        </div>
        <Button as="button" size="small" className="w-full" onClick={handleNext}>
          Done
        </Button>
      </div>
    </div>
  );
};

export default DownloadApp;
